import { defineStore } from "pinia";

export const useCategoryStore = defineStore('category', {
    state: () => ({
        category: {},
        categories: [],
    }),
    actions: {
        setCategory(category) {
            this.category = category
        },
        setCategories(categories) {
            this.categories = categories
        },
        addCategory(category) {
            this.categories.unshift(category)
        },
        updateCategory(category) {
            let index = this.categories.findIndex(cl => cl.id === category.id)
            this.categories.splice(index, 1, category)
        },
        deleteCategory(category) {
            let index = this.categories.findIndex(cl => cl.id === category.id)
            this.categories.splice(index, 1)
        },
    },
});